import BaseApi from '@/api/BaseApi';
import type { IPaginate } from '@/models/TableSettingsModel';
import type {
    ICreateEditSalesRepRequest,
    ISalesRepCardsResponse,
    ISalesRepDetailsResponse,
    ISalesRepItemResponse,
    ISalesRepLoginsResponse,
    ISalesRepQuizResponse,
    IResentEmail,
} from '@/models/SalesRepModel';

export default class SalesRepApi extends BaseApi {
    async salesRepList (page: number, perPage: number, sortBy: string | null, sortDesc: string | null, isSalesRepReg: boolean, search: string | null) {
        let url = `/api/users?page=${page}&per_page=${perPage}&${isSalesRepReg ? 'role=seller_reg' : 'role=seller'}`;

        if (null != sortBy) {
            url += `&sort=${sortBy}`;
        }

        if (null != sortDesc) {
            url += `&order=${sortDesc}`;
        }

        if (null != search) {
            url += `&search=${search}`;
        }

        return this.get<IPaginate<ISalesRepItemResponse>>({
            url: url,
        });
    };
    async warehouseSalesRepList (page: number, perPage: number, sortBy: string | null, sortDesc: string | null, warehouseId: string | string[], search: string | null) {
        let url = `/api/warehouses/${warehouseId}/users?role=seller&page=${page}&per_page=${perPage}`;

        if (null != sortBy) {
            url += `&sort=${sortBy}`;
        }

        if (null != sortDesc) {
            url += `&order=${sortDesc}`;
        }

        if (null != search) {
            url += `&search=${search}`;
        }

        return this.get<IPaginate<ISalesRepItemResponse>>({
            url: url,
        });
    };

	async deleteSalesRep (salesRepId: number) {
		return this.delete({
			url: `/api/users/${salesRepId}`,
		});
	};

	async createSalesRep (payload: ICreateEditSalesRepRequest) {
		return this.post<ICreateEditSalesRepRequest, any>({
			url: `/api/users`,
            data: payload,
		});
	};

	async editSalesRep (payload: ICreateEditSalesRepRequest, salesRepId: string | string[]) {
		return this.put<ICreateEditSalesRepRequest, any>({
			url: `/api/auth/profile/${salesRepId}`,
            data: payload,
		});
	};

	async salesRepDetails (salesRepId: string | string[]) {
		return this.get<ISalesRepDetailsResponse>({
			url: `/api/users/${salesRepId}`,
		});
	};

    async salesRepLoginList (salesRepId: string | string[], page: number, perPage: number, sortBy: string | null, sortDesc: string | null) {
        let url = `/api/users/${salesRepId}/logins?page=${page}&per_page=${perPage}`;

        if (null != sortBy) {
            url += `&sort=${sortBy}`;
        }

        if (null != sortDesc) {
            url += `&order=${sortDesc}`;
        }

        return this.get<IPaginate<ISalesRepLoginsResponse>>({
            url: url,
        });
    };

    async salesRepCardsList (salesRepId: string | string[], page: number, perPage: number, sortBy: string | null, sortDesc: string | null) {
        let url = `/api/sales-rep/${salesRepId}/cards?page=${page}&per_page=${perPage}`;

        if (null != sortBy) {
            url += `&sort=${sortBy}`;
        }

        if (null != sortDesc) {
            url += `&order=${sortDesc}`;
        }

        return this.get<IPaginate<ISalesRepCardsResponse>>({
            url: url,
        });
    };

    async salesRepQuizList (salesRepId: string | string[], page: number, perPage: number, sortBy: string | null, sortDesc: string | null, search: string | null) {
        let url = `/api/users/${salesRepId}/quiz?page=${page}&per_page=${perPage}`;

        if (null != sortBy) {
            url += `&sort=${sortBy}`;
        }

        if (null != sortDesc) {
            url += `&order=${sortDesc}`;
        }

        if (null != search) {
            url += `&search=${search}`;
        }

        return this.get<IPaginate<ISalesRepQuizResponse>>({
            url: url,
        });
    };

    async sendActivateLinkToUser (payload: IResentEmail) {
        return this.post<IResentEmail, any>({
            url: '/api/resend-set-password',
            data: payload,
        });
    };
};
